import { TApiExport } from '@modules/LoyaltyProgramme/types';
import { ApiRequest } from '@zeal/zeal-lib';
import { ENDPOINTS } from '../endpoints';

export async function apiDownloads({ queryKey: [, filters] }: any) {
	return new ApiRequest(ENDPOINTS.loyaltyProgramme.downloads.list)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.addQuery('page', filters.page)
		.addQuery('type', 'loyalty')
		.GET<ApiResponseWithPagination<TApiExport>>();
}
